
const routes = {
  home: "/",
  calculadora: "/calculadora",
  baseDocumental: "/baseDocumental",
  enlaces: "/enlaces",
  resultados: "/resultados",
  login: '/login',
  maestro: '/maestros',
  informe: '/generadorInformes',
  reportesNormativos: '/reportes-normativos',
  dashboard: '/indicadores',
  indicadorGubernamental: '/indicador-gubernamental',
  paiRegistro: '/pai/nuevo-registro',
  planParto: '/plan-parto',
  citologia: '/citologia',
  carguePacientesMasivos: '/configuracion/cargue-pacientes-masivos',
  logsServicios: '/herramientas/logs-sincronizador',
  soporte: '/soporte',
  patientPortal: '/portal-paciente',
  patientPortalLogin: '/portal-paciente/login',

  error: "/404"
};


export default routes;
